<template>
  <div class="backgroud-white cs-courseSchedule-editor">
    <div class="backgroud-gray-popup popup-content-area-small">
      <el-form ref="form" :model="form">
        <el-form-item prop="courseType" label="课程类型" label-width="150px" class="label-strong">
          <el-select v-model="form.courseType" placeholder="请选择课程类型" @change="onCourseTypeChanged">
            <el-option v-for="item in courseTypes" :key="item.Value" :label="item.Text" :value="item.Value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.courseType == 3" prop="trainingCategoryId" label="业务" label-width="150px" class="label-strong">
          <el-select v-model="form.trainingCategoryId" placeholder="请选择业务" @change="onTrainingCategoryChanged">
            <el-option v-for="item in trainingCategoryList" :key="item.Id" :label="item.Name" :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="termId" label="学期" label-width="150px" class="label-strong">
          <el-select
            @change="onTermChange"
            v-model="form.termId"
            placeholder="请选择学期"
            :disabled="form.courseType == 3 && !form.trainingCategoryId">
            <el-option v-for="item in termList" :key="item.Id" :label="item.DisplayLable" :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="removeYearCourse" label="是否清理年课视频" label-width="150px" class="label-strong">
          <el-checkbox v-model="form.removeYearCourse" class="input-width"></el-checkbox>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
      <el-row>
        <el-col :span="20" :xs="16" class="footer-left">
          <span v-if="!showError"></span>
          <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
        </el-col>
        <el-col class="footer-right" :span="4" :xs="8">
          <el-button :disabled="submitBtnDisable" :type="submitBtnClass" @click="save()">确认</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getPreCurrentTerms, getTrainingCategoryList } from "../service/common.service";
import { getCourseType } from "../config/mUtils";

export default {
  data() {
    return {
      showError: false,
      errorMessage: "",
      submitBtnClass: "primary",
      submitBtnDisable: false,
      courseTypes: [],
      trainingCategoryList: [],
      termList: [],
      form: {
        courseType: 1,
        trainingCategoryId: "",
        termId: "",
        removeYearCourse: true
      }
    };
  },
  created() {
    this.courseTypes = getCourseType(true);
    this.loadTrainingCategoryList();
    this.loadTermList();
  },
  watch: {},
  methods: {
    onCourseTypeChanged() {
      this.form.termId = "";
      this.termList = [];
      if (this.form.courseType == 3) {
        if (!this.form.trainingCategoryId && this.trainingCategoryList.length > 0) {
          this.form.trainingCategoryId = this.trainingCategoryList[0].Id;
        }
        if (this.form.trainingCategoryId) {
          this.loadTermList();
        }
      } else {
        this.form.trainingCategoryId = "";
        this.loadTermList();
      }
    },
    onTrainingCategoryChanged() {
      this.form.termId = "";
      this.loadTermList();
    },
    onTermChange() {
      // reserved for future cascading actions
    },
    loadTrainingCategoryList() {
      getTrainingCategoryList(3).then(result => {
        if (!!result && result.success) {
          this.trainingCategoryList = result.data || [];
        } else {
          this.trainingCategoryList = [];
        }
      });
    },
    loadTermList() {
      let termType = 1;
      let trainingCategoryId = 0;
      if (this.form.courseType == 3) {
        if (!this.form.trainingCategoryId) {
          this.termList = [];
          return;
        }
        termType = 2;
        trainingCategoryId = this.form.trainingCategoryId;
      }
      getPreCurrentTerms(termType, trainingCategoryId).then(result => {
        if (!!result && result.success) {
          this.termList = result.data || [];
          const current = this.termList.find(i => i.IsCurrentTerm);
          if (current) {
            this.form.termId = current.Id;
          } else if (this.termList.length > 0) {
            this.form.termId = this.termList[0].Id;
          }
        } else {
          this.termList = [];
        }
      });
    },
    checkAllInputs() {
      let isValid = true;
      this.$refs.form.validate(valid => {
        if (!valid) {
          isValid = false;
          return;
        }
      });
      if (this.form.courseType == 3 && !this.form.trainingCategoryId) {
        this.showError = true;
        this.errorMessage = "请选择业务";
        return false;
      }
      if (!this.form.termId) {
        this.showError = true;
        this.errorMessage = "请选择学期";
        return false;
      }
      this.showError = false;
      return isValid;
    },
    close() {
      this.$refs["form"].resetFields();
      this.$emit("close");
    },
    save() {
      let valid = this.checkAllInputs();
      if (!valid) return;
      let term = this.termList.find(i => i.Id == this.form.termId);
      if (!!term) {
        let data = {
          termId: this.form.termId,
          termName: term.DisplayLable,
          removeYearCourse: this.form.removeYearCourse,
          courseType: this.form.courseType,
          trainingCategoryId: this.form.courseType == 3 ? this.form.trainingCategoryId : 0
        };
        this.$emit("save", data);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/selectTerm.vue